import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ApiService } from "../../services/api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TankmixTest } from "../../models/searchRequest";
import { faPrint, faArrowLeft,faShare,faClipboard } from "@fortawesome/free-solid-svg-icons";
import { PreferencesService } from "../../services/preferences.service";
import { tap } from "rxjs";
@Component({
  selector: "app-tankmix-detail",
  templateUrl: "./tankmix-detail.component.html",
})
export class TankmixDetailComponent implements OnInit {
  [x: string]: any;
  faPrint = faPrint;
  faArrowLeft = faArrowLeft;
  faShare = faShare;
  faClipboard=faClipboard;
  testResult: TankmixTest;
  unitsChoice: string;
  canShare: boolean=true;
  countryCode: string;
  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private preferencesService: PreferencesService,
    private location: Location
  ) {
   // this.canShare = window?.navigator?.share != null;
  }

  ngOnInit() {

    this.preferencesSub = this.preferencesService.countryCode$.subscribe(
      (countryCode) => {
        console.log(countryCode);
        this.countryCode = countryCode;
      }
    );

    this.api
      .getOutcome(
        this.route.snapshot.params.tankmixId,
        this.route.snapshot.params.languageCode,
        this.countryCode,

      )
      .subscribe((x) => {
        console.log("test result");
        this.testResult = x;
      });
    this.preferencesService.unitsChoice$
      .pipe(
        tap((unitsChoice) => {
          this.unitsChoice = unitsChoice;
        })
      )
      .subscribe();

     
  }
  convertedAppRate(inp: number) {
    return this.preferencesService.convertApplicationUnits(inp);
  }
  convertedWaterRate(inp: number) {
    return this.preferencesService.convertWaterUnits(inp);
  }
  convertPowderUnits(inp: number) {
    return this.preferencesService.convertPowderUnits(inp);
  }
  back() {
    this.location.back();
  }
  share() {
    navigator.clipboard.writeText(window.location.href)
   
  }
}
